export default __webpack_public_path__ + "static/media/ic_attach_money_48px.c3f108b4.svg";